"use strict";
var vec3 = require('gl-matrix/src/gl-matrix/vec3');
function triarea2(o, a, b) {
    var ax = a[0] - o[0];
    var az = a[2] - o[2];
    var bx = b[0] - o[0];
    var bz = b[2] - o[2];
    return bx * az - ax * bz;
}
function vequal(a, b) {
    return vec3.sqrDist(a, b) < 0.00001;
}
var Channel = (function () {
    function Channel() {
        this.portals = [];
    }
    Channel.prototype.push = function (p1, p2) {
        if (p2 === undefined)
            p2 = p1;
        this.portals.push({ left: p1, right: p2 });
    };
    ;
    Channel.prototype.stringPull = function () {
        var portals = this.portals;
        var pts = [];
        // Init scan state
        var apexIndex = 0;
        var leftIndex = 0;
        var rightIndex = 0;
        var portalApex = portals[0].left;
        var portalLeft = portals[0].left;
        var portalRight = portals[0].right;
        // Add start point.
        pts.push(portalApex);
        for (var i = 1, len = portals.length; i < len; i++) {
            var left = portals[i].left;
            var right = portals[i].right;
            // Update right vertex.
            if (triarea2(portalApex, portalRight, right) >= 0.0) {
                if (vequal(portalApex, portalRight) || triarea2(portalApex, portalLeft, right) < 0.0) {
                    // Tighten the funnel.
                    portalRight = right;
                    rightIndex = i;
                }
                else {
                    // Right over left, insert left to path and restart scan from portal left point.
                    pts.push(portalLeft);
                    // Make current left the new apex.
                    portalApex = portalLeft;
                    apexIndex = leftIndex;
                    // Reset portal
                    portalLeft = portalApex;
                    portalRight = portalApex;
                    leftIndex = apexIndex;
                    rightIndex = apexIndex;
                    // Restart scan
                    i = apexIndex;
                    continue;
                }
            }
            // Update left vertex.
            if (triarea2(portalApex, portalLeft, left) <= 0.0) {
                if (vequal(portalApex, portalLeft) || triarea2(portalApex, portalRight, left) > 0.0) {
                    // Tighten the funnel.
                    portalLeft = left;
                    leftIndex = i;
                }
                else {
                    // Left over right, insert right to path and restart scan from portal right point.
                    pts.push(portalRight);
                    // Make current right the new apex.
                    portalApex = portalRight;
                    apexIndex = rightIndex;
                    // Reset portal
                    portalLeft = portalApex;
                    portalRight = portalApex;
                    leftIndex = apexIndex;
                    rightIndex = apexIndex;
                    // Restart scan
                    i = apexIndex;
                    continue;
                }
            }
        }
        if ((pts.length === 0) || (!vequal(pts[pts.length - 1], portals[portals.length - 1].left))) {
            // Append last point to path.
            pts.push(portals[portals.length - 1].left);
        }
        this.path = pts;
        return pts;
    };
    ;
    return Channel;
}());
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Channel;
//# sourceMappingURL=Channel.js.map


/*****************
 ** WEBPACK FOOTER
 ** /Users/songseunggeun/voxeline/pathfinder/lib/Channel.js
 ** module id = 1156
 ** module chunks = 0
 **/